module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal-1"
  }, [_vm._v("“The days of visitation are come,")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("the days of recompence are come;")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("Israel shall know it: the prophet is")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("a fool, the spiritual man is mad …”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—Hosea, 9:7")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-2"
  }, [_vm._v("“But whereunto shall I liken")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("this generation? It is like")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("unto children sitting in the")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("markets, and calling unto")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("their fellows,")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("And saying, We have piped")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("unto you, and ye have not")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("danced; we have mourned unto")]), _vm._v(" "), _c('p', {
    staticClass: "normal-3"
  }, [_vm._v("you, and ye have not lamented.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—St. Matthew, 11:16, 17")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-2"
  }, [_vm._v("“Fathers and teachers, I ponder ‘What is hell?’ I maintain that it is the suffering of being unable to love.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—Father Zossima")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495aa1af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 69
// module chunks = 0